import { ContentManagerModule, SxcRootModule } from '@2sic.com/sxc-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { routes } from './app.routes';
import { AuthService } from './auth/auth.service';
import { HandleErrorsInterceptor } from './handle-errors.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      // withHashLocation()
    ),
    importProvidersFrom(
      BrowserModule, // this tells Angular to run in a browser
      // 2sxc Module #StepBootstrap
      SxcRootModule, // this is important in the app-root, as it ensures that context is shared in sub-modules
      ContentManagerModule,
    ),
    CookieService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleErrorsInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
